// import jwtDecode from "jwt-decode";
import http from "./httpService";
import Cookies from 'universal-cookie';
import { apiUrl, staticToken } from "../config.json";

const cookies = new Cookies();
const tokenKey = "token";
// http.setJwt(staticToken);

export function loginWithJwt(jwt) {
  cookies.set(tokenKey, jwt, { path: '/' });
}

export async function logout() {
 await cookies.remove('__info', { path: '/' });
 await cookies.remove("__cartAmount", { path: '/' });
 await cookies.remove(tokenKey, { path: '/' });
}

export function getCurrentUser() {
    try {
      const jwt = cookies.get(tokenKey);
      console.log(jwt)
      // jwtDecode(jwt)
      return true;
    } catch (ex) {
      return false;
    }
  }
export const storeData = (key, value) => {
  cookies.set(key, value, { path: '/' });
}

export function getJwt(key) {
  return cookies.get(key);
}

export const login = (data) => {
  const apiEndPoint = `${apiUrl}/CM_UserLogin`;
  return http.post(apiEndPoint, data)
}

export const localstore = (UserId,UserName,MobileNo,EmailId) =>{
  localStorage.setItem("UserId", UserId);
  localStorage.setItem("UserName", UserName)
  localStorage.setItem("MobileNo", MobileNo)
  localStorage.setItem("EmailId", EmailId)
  localStorage.setItem("CREATEDBY", UserId)
  localStorage.setItem("UPDATEDBY", UserId)
}

  export const getLocalStorageValues = (key) =>{
    return localStorage.getItem(key);
  }

  export const setLocalStorevalue=(key,value)=>{
    localStorage.setItem(key, value);
  }
export default {
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt
};
